import { englishDomTheme } from "../englishdom/theme.config.js";
const assetBase = "/assets/quizzes/englishdom";
const sharedDemoAssets = "/assets/quizzes/demo";
const planScore = { personal_plan: 1 };
export const personalPlanQuiz = {
    id: "englishdom-personal-plan",
    slug: "personal-plan",
    version: 1,
    presentation: {
        style: "expressive",
        flowLayout: "compact",
        firstQuestionLayout: "portrait-pair",
        entryComposition: "compact-cluster",
        questionTransition: "fade-y",
        portraitCrops: {
            female: { scale: 1.03, objectPosition: "50% 0%", offsetY: "1.5%", transformOrigin: "50% 0%", background: "#ddddfa" },
            male: { scale: 1, objectPosition: "50% 0%", background: "#ffd8be" }
        },
        counter: { enabled: true, totalSteps: 7, excludeQuestionIds: ["gender"] },
        resultGate: "personal-plan",
        analysisVisual: {
            type: "animated-image",
            src: `${assetBase}/cat-wheel.webp`,
            reducedMotionSrc: `${assetBase}/cat-wheel-still.webp`,
            width: 400,
            height: 225,
            alt: "",
            crop: "contain",
            motion: "none",
            placement: "heading-above",
            shape: "rounded"
        },
        completion: {
            mode: "telegram",
            lockedTitle: "Твій план навчання готовий 🔒",
            lockedText: "Ми вже врахували твої відповіді та підготували персональний план.",
            successTitle: "Твій персональний план готовий 💚",
            successText: "Дякуємо! Твій персональний план готовий — переходь до наступного кроку в англійській.",
            ctaLabel: "Отримати персональний план",
            ctaUrl: "https://t.me/englishdom_ua_bot/?start=qz=quiz__tfm=pp3"
        }
    },
    metadata: {
        name: "EnglishDom",
        language: "uk",
        description: "Personal English learning plan quiz for EnglishDom."
    },
    startQuestionId: "gender",
    landing: { enabled: false, sections: [] },
    start: {
        enabled: true,
        renderer: "native",
        mode: "first-question",
        layout: "split-question",
        eyebrow: "7 запитань · персональний план",
        title: "Отримай персональний план англійської під свої цілі",
        subtitle: "Відповідай на 7 коротких запитань — ми врахуємо твій рівень, цілі, бажаний темп навчання та те, що зараз найбільше заважає рухатися вперед.\n\nНаприкінці отримаєш персональний план, який допоможе зрозуміти, на чому сфокусуватися та як рухатися до результату без хаосу.",
        cta: { label: "Почати тест", action: "startQuiz" },
        background: { type: "color", value: "#4FC87B" },
        logo: { enabled: true, src: `${assetBase}/logo-white.png`, alt: "EnglishDom" }
    },
    progress: {
        mode: "stages",
        stages: [
            { id: "entry", weight: 0 },
            { id: "question-1", weight: 14.2857 },
            { id: "question-2", weight: 14.2857 },
            { id: "question-3", weight: 14.2857 },
            { id: "question-4", weight: 14.2857 },
            { id: "question-5", weight: 14.2857 },
            { id: "question-6", weight: 14.2857 },
            { id: "question-7", weight: 14.2858 }
        ]
    },
    phone: {
        defaultCountry: "UA",
        preferredCountries: ["UA", "CZ", "PL", "DE"],
        searchable: true
    },
    questions: [
        {
            id: "gender",
            type: "single-choice",
            stage: "entry",
            title: "Обери стать",
            answers: [
                { id: "female", label: "Жінка", media: { src: `${assetBase}/woman-v7.png`, alt: "" }, next: "english_level", scores: {} },
                { id: "male", label: "Чоловік", media: { src: `${sharedDemoAssets}/answers/man-v4.webp`, alt: "" }, next: "english_level", scores: {} }
            ]
        },
        {
            id: "english_level",
            type: "single-choice",
            stage: "question-1",
            title: "Чи знаєш ти рівень своєї англійської?",
            answers: [
                { id: "unknown", emoji: "🤔", label: "Не знаю свого рівня", next: "learning_goal", scores: planScore },
                { id: "none", emoji: "🙈", label: "Взагалі не знаю англійської", next: "learning_goal", scores: planScore },
                { id: "a1", emoji: "🐣", label: "A1 - впізнаю окремі слова", next: "learning_goal", scores: planScore },
                { id: "a2", emoji: "🐒", label: "A2 - можу спілкуватися простими реченнями", next: "learning_goal", scores: planScore },
                { id: "b1", emoji: "🐸", label: "B1 - підтримую нескладні теми, розумію текст «по діагоналі»", next: "learning_goal", scores: planScore },
                { id: "b2", emoji: "🦅", label: "B2 - дивлюся серіали без субтитрів", next: "learning_goal", scores: planScore },
                { id: "c1", emoji: "🦚", label: "C1 - let me speak from my heart", next: "learning_goal", scores: planScore }
            ]
        },
        {
            id: "learning_goal",
            type: "single-choice",
            stage: "question-2",
            title: "З якою метою ти вчиш англійську?",
            subtitle: "Можуть бути одразу і всі. Та спробуй обрати найпріоритетнішу:",
            answers: [
                { id: "travel", emoji: "🏖️", label: "Щоб у подорожах (або житті закордоном), почуватися як риба у воді", next: "desired_speed", scores: planScore },
                { id: "career", emoji: "📈", label: "Для кар’єрного росту", next: "desired_speed", scores: planScore },
                { id: "original_content", emoji: "🎬", label: "Хочу дивитись фільми та читати книжки в оригіналі", next: "desired_speed", scores: planScore },
                { id: "international_events", emoji: "📅", label: "Щоб брати участь в міжнародних воркшопах, форумах, семінарах", next: "desired_speed", scores: planScore },
                { id: "ielts_toefl", emoji: "✅", label: "Щоб успішно скласти IELTS/TOEFL", next: "desired_speed", scores: planScore },
                { id: "self_development", emoji: "🧠", label: "Для саморозвитку", next: "desired_speed", scores: planScore },
                { id: "other", emoji: null, label: "Інше", next: "desired_speed", scores: planScore }
            ]
        },
        {
            id: "desired_speed",
            type: "single-choice",
            stage: "question-3",
            title: "Як швидко ти хочеш підвищити рівень інгліша?",
            subtitle: "Це допоможе нам порекомендувати тобі курс та інтенсивність занять",
            answers: [
                { id: "three_months", emoji: "🔥", label: "До 3-х місяців", next: "preferred_learning_format", scores: planScore },
                { id: "six_months", emoji: "🏃", label: "Півроку максимум", next: "preferred_learning_format", scores: planScore },
                { id: "one_year", emoji: "👌", label: "Рік — норм", next: "preferred_learning_format", scores: planScore },
                { id: "ongoing", emoji: "🔄", label: "Хочу вчити постійно", next: "preferred_learning_format", scores: planScore }
            ]
        },
        {
            id: "preferred_learning_format",
            type: "single-choice",
            stage: "question-4",
            title: "Якому формату навчання ти віддаєш перевагу?",
            subtitle: "Що для тебе ефективніше: навчатися разом із іншими чи мати викладача лише для себе?",
            answers: [
                { id: "individual", emoji: "🎯", label: "Індивідуальний, наодинці з вчителем", next: "usage_frequency", scores: planScore },
                { id: "group", emoji: "👥", label: "Груповий, в міні-групі до 7 людей", next: "usage_frequency", scores: planScore },
                { id: "unsure", emoji: "🤷", label: "Не знаю, треба дізнатись деталі", next: "usage_frequency", scores: planScore }
            ]
        },
        {
            id: "usage_frequency",
            type: "single-choice",
            stage: "question-5",
            title: "Як часто ти використовуєш англійську?",
            subtitle: "Дивитися відео на Youtube та в Tik-tok теж враховується 😉",
            answers: [
                { id: "daily", emoji: "☀️", label: "Щодня", next: "main_challenge", scores: planScore },
                { id: "few_times_week", emoji: "🌤️", label: "Два-три рази на тиждень", next: "main_challenge", scores: planScore },
                { id: "few_times_month", emoji: "⛅", label: "Пару разів на місяць", next: "main_challenge", scores: planScore },
                { id: "almost_never", emoji: "🌧️", label: "Майже не використовую", next: "main_challenge", scores: planScore }
            ]
        },
        {
            id: "main_challenge",
            type: "single-choice",
            stage: "question-6",
            title: "Найбільший челендж в англійській для тебе — це ...?",
            subtitle: "Чим більший перед нами стоїть виклик, тим приємнішою буде перемога над ним 💪",
            answers: [
                { id: "speaking", emoji: "🤐", label: "Спікати", next: "weekly_study_commitment", scores: planScore },
                { id: "vocabulary", emoji: "🤓", label: "Маю невеликий словниковий запас", next: "weekly_study_commitment", scores: planScore },
                { id: "grammar", emoji: "🤯", label: "Чорт ногу зламає в тій граматиці", next: "weekly_study_commitment", scores: planScore },
                { id: "listening", emoji: "👂", label: "Не розумію на слух, що говорять", next: "weekly_study_commitment", scores: planScore },
                { id: "professional_vocabulary", emoji: "💼", label: "Не володію спец лексикою", next: "weekly_study_commitment", scores: planScore }
            ]
        },
        {
            id: "weekly_study_commitment",
            type: "single-choice",
            stage: "question-7",
            title: "Скільки часу протягом тижня ти плануєш присвятити інглішу?",
            subtitle: "Вчи двічі на тиждень і за півроку охопиш популярні теми, а щоденні заняття швидко апнуть до нового рівня 📈",
            answers: [
                { id: "one_lesson", emoji: "👌", label: "Почну хоча б з одного заняття", next: "__end__", scores: planScore },
                { id: "two_lessons", emoji: "😎", label: "Знайду час на 2 заняття з викладачем", next: "__end__", scores: planScore },
                { id: "two_lessons_plus_speaking", emoji: "🤩", label: "Пару занять з тічером + ще 1-2 спікінг-клаби", next: "__end__", scores: planScore },
                { id: "intensive", emoji: "😍", label: "2-3 рази з тічером і ще самостійно щоденно", next: "__end__", scores: planScore }
            ]
        }
    ],
    scoring: {
        categories: ["personal_plan"],
        normalizeTo: 100,
        tieBreaker: ["personal_plan_ready"]
    },
    results: [
        {
            id: "personal_plan_ready",
            category: "personal_plan",
            title: "Персональний план англійської",
            shortTitle: "План",
            description: "План підготовлено за твоїми відповідями.",
            preview: "Наступний крок уже готовий.",
            gatedContent: "Персональний план готовий до видачі.",
            scoreLabel: "Готовність плану",
            priority: 1
        }
    ],
    analysis: {
        title: "Формуємо твій персональний план",
        subtitle: "Аналізуємо відповіді та збираємо наступний крок під твої цілі.",
        display: "stage-cards",
        durationMs: 3900,
        reducedMotionDurationMs: 400,
        steps: [
            { id: "answers", title: "Аналізуємо твої відповіді" },
            { id: "goals", title: "Зіставляємо рівень, цілі та темп" },
            { id: "plan", title: "Готуємо персональний план" }
        ],
        checkpoints: [0, 18, 36, 54, 72, 90, 100]
    },
    leadForm: {
        title: "Залишити контакти",
        subtitle: "Після заповнення форми тобі автоматично відкриється доступ.",
        placement: "inline-result",
        fields: {
            name: { enabled: true, required: true, label: "Ім'я" },
            phone: { enabled: true, required: true, label: "Телефон" },
            email: { enabled: true, required: true, label: "Електронна пошта" }
        },
        privacyConsentRequired: true,
        marketingConsentEnabled: true,
        submitLabel: "Забрати план"
    },
    integrations: {
        googleSheets: {
            enabled: true,
            questionHeaderMode: "question_ids"
        }
    },
    uiCopy: {
        resultEyebrow: "Персональний план",
        lockedTitle: "Твій план навчання готовий 🔒",
        lockedText: "Ми вже врахували твої відповіді та підготували персональний план.",
        fullResultTitle: "Доступ до плану",
        resultCta: "Відкрити план",
        leadSaved: "Заявку збережено",
        fullResultReady: "Твій персональний план готовий 💚"
    },
    theme: englishDomTheme
};
